import * as React from 'react'
import * as $ from 'jquery'
import {ReactElement, useEffect, useState} from "react";
import {Loader} from "./Loader";
import "../css/works.scss"
import Skeleton from "react-loading-skeleton";

interface WorkLink {
    title: string
    url: string
}

interface Work {
    title: string
    image: string
    description: string
    dueDates: string
    links: [WorkLink]
}

interface WorkResponse {
    status: number
    data: [Work] | undefined
}

const initialWorkResponse: WorkResponse = {status: 0, data: undefined}

export const Works : React.FC<{}> = () => {
    const [works, setWorks] = useState<WorkResponse>(initialWorkResponse);
    const [index, setIndex] = useState(3);

    function receiveData() {
        $.ajax("https://script.google.com/macros/s/AKfycbzX2aPXNPnl9FbIVYXA62jt-JAbII9WSyyolTX4Y3QZr59ywuI/exec?type=works", {
            type: "get"
        }).done((data) => {
            console.log(data);
            setWorks(data);
        });
    }
    useEffect(() => {
        receiveData();
    }, [initialWorkResponse]);

    function showData() {

        if (works.status === 200) {
            const maps = [];
            const length = Math.min(works.data.length, index);
            for(var i = 0; i < length; i += 3) {
                maps.push(works.data.slice(i, i + 3));
            }

            function showMore() {
                if (length > index) {
                    return (
                        <div className="container center">
                            <button className="button is-primary" onClick={() => {setIndex(index + 3)}}>More</button>
                        </div>
                    )
                }
                return (
                    <div className="container center">
                        <button className="button is-static">More</button>
                    </div>
                )
            }

            return (
                <React.Fragment>
                    {maps.map((e, i) => {
                        return (
                            <div className={"tile is-ancestor"} key={"parent" + i}>
                                {e.map(showWork)}
                            </div>
                        );
                    })}
                    {showMore()}
                </React.Fragment>
            );
        }

        const map = [0,1,2];

        function showError() {
            if(works.status === 200 || works.status === 0) {
                return null;
            }
            return (
                <div className="notification is-danger">データ取得に失敗しました。 <a href={"https://twitter.com/br_branch"} target={"_blank"}>Twitter</a>で教えてもらえると嬉しいです。</div>
            );
        }

        return (
            <React.Fragment>
                <div className={"tile is-ancestor"} key={"skelton" + i}>
                {map.map(i => {
                    return (
                        <div className={"tile work-tile is-4"} key={"child" + i}>
                            <div className={"panel work-skelton"}>
                                <div className={"panel-heading"}>
                                    <Skeleton/>
                                </div>
                                <div>
                                    <Skeleton height={100}/>
                                </div>
                                <div className={"panel-block skelton"}>
                                    <Skeleton height={40}/>
                                </div>
                                <div className={"panel-block skelton"} >
                                    <Skeleton count={2}/>
                                </div>
                                <div className={"panel-block skelton"}>
                                    <Skeleton/>
                                </div>
                            </div>
                        </div>);
                })}
                </div>
                <div className="container center">
                    <button className="button is-static is-loading">More</button>
                </div>
                {showError()}
            </React.Fragment>
        );
    }

    function showWork(work: Work, index: number) {
        function showLink(links: [WorkLink]) {
            if(links === undefined || links.length <= 0) {
                return null;
            }
            return links.map((e, i) => {
                return (
                    <a className="panel-block" target={"_blank"} href={e.url} key={i}>
                        <span className="panel-icon">
                          <i className="fas fa-link" aria-hidden="true"></i>
                        </span>
                        {e.title}
                    </a>
                )
            });
        }

        return (
            <div className={"tile work-tile is-4"} key={work.image}>
                <div className={"panel"} style={{animationDelay: `${index * 0.05}s`}}>
                    <div className={"panel-heading"}>
                        {work.title}
                    </div>
                    <div>
                        <img src={work.image}/>
                    </div>
                    <div className={"panel-block"}>
                        <div className={"work-duedate"}> 制作期間</div> <div className={"work-dueDates"}>{work.dueDates}</div>
                    </div>
                    <div className={"panel-block"}>
                        {work.description}<br/>
                    </div>
                    {showLink(work.links)}
                </div>
            </div>
        )
    }

    return (
        <div className={`container works-root`}>
            <h1 className={"title"}>Works</h1>
            <div className="subtitle">
                個人で作ったもののみ
            </div>
            {showData()}
        </div>
    );
}
